import * as React from 'react';
import { EyeIcon, EyeSlashIcon } from "@phosphor-icons/react";
import { Button } from '@tranquility-ai/theme-components/button';

const Visibility = (props: any) => {
  const { data, size, onClick } = props;
  const iconSize = size || 22;
  const paddingTop = size ? '' : 'pt-[3px]';
  let className = 'text-red-500';
  let icon = <EyeSlashIcon weight="duotone" size={iconSize} />;
  if (data.show === true) {
    className = 'text-green-500';
    icon = <EyeIcon size={iconSize} weight="duotone" />;
  }

  const handleClick = () => {
    if (onClick) {
      onClick(data.displayOrder);
    }
  };

  return (
    <Button
      iconOnly
      size="sm"
      style="text"
      color="light"
      background="inverse"
      aria-label={data.show === true ? "Hide event" : "Show event"}
      className={`cursor-pointer flex justify-center border-0 ${paddingTop} ${className}`}
      onClick={handleClick}
    >
      {icon}
    </Button>
  );
};

Visibility.displayName = 'Visibility';

export default Visibility;
